import React from 'react';
import './App.css';
import history from './history';

import { BrowserRouter, Route, Routes } from "react-router-dom";
// import { Switch } from 'react-router';
import routes from "./routes"

const App = () => {
    return (
        <BrowserRouter history={history}>
            <Routes>
                {routes.map((route, i) => {
                    return <Route key={i} path={route.path} Component={route.component} />
                })}
            </Routes>
        </BrowserRouter>
    )
}

export default App